module.exports = __webpack_public_path__ + "static/img/img7.14d6029.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img7.jpg
// module id = 0zfK
// module chunks = 1